// space we reserve for graph labels
export const SVG_ANCILLARY_SPACE = 35;

export const CARD_HEADER_HEIGHT = 52;
export const CARD_MAX_WIDTH = 1784;
export const CARD_LABEL_MIN_WIDTH = 300;
export const CARD_CHART_MIN_WIDTH = 420;
export const CARD_TABLE_MIN_WIDTH = 856;

export const CHART_LABEL_CHAR_WIDTH = 6;
export const CHART_HOVER_OPACITY = 0.24;
export const CHART_HOVER_TRANSITION = 'fill-opacity 0.2s ease-in-out,  opacity 0.2s ease-in-out';
export const CHART_CONTAINER_HEIGHT = 372;
export const CHART_CONTENT_HEIGHT = 280;

export const BAR_WIDTH = 32;
export const BAR_CHART_BAR_LABEL_OFFSET_Y = 20;
export const BAR_CHART_Y_AXIS_OFFSET_X = 50;
export const BAR_CHART_Y_AXIS_LABEL_OFFSET_X = 10;
export const BAR_CHART_X_AXIS_LABEL_OFFSET_Y = 10;
export const BAR_CHART_Y_AXIS_OFFSET_Y = 10;
export const BAR_CHART_Y_AXIS_NUM_TICKS = 5;
export const BAR_CHART_BAR_PADDING = 0.2;
export const BAR_CHART_Y_AXIS_PADDING_RIGHT = 10;
export const BAR_CHART_TOOLTIP_BUFFER_WIDTH = 100;

export const PIE_CHART_HEIGHT = 154;
export const PIE_CHART_LEGEND_ITEMS_GAP = 4;
export const PIE_CHART_LEGEND_ITEM_LABEL_OFFSET = 1;
export const PIE_CHART_RADIUS_DIFFERENCE = 20;
export const PIE_CHART_LEGEND_GAP = 16;
export const PIE_CHART_INNER_TEXT_Y_OFFSET = -5;
export const PIE_CHART_INNER_TEXT_GAP = 8;

export const OTHER_VALUE = 'other';
export const OTHER_LABEL = 'Other';
export const OTHER_COLOR = '#BAB0AB';
export const TOTAL_LABEL = 'Total';

export const TOOLTIP_MAX_COL_COUNT = 20;

export const COLOR_WHEEL = [
  '#4F79A7',
  '#F28E2C',
  '#E1575A',
  '#77B7B3',
  '#58A14E',
  '#EDC949',
  '#AF7AA1',
  '#FF9DA7',
  '#9C755F',
  '#BC6A3C',
];

export const NO_RESULTS_FOUND_MESSAGE = 'No records found';
